import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import {
  deleteOverviewTablesFilter,
  setOverviewTablesAction,
  setOverviewTablesFilter,
  setOverviewTablesLoading,
} from "./actionCreators";
import { OverviewTablesReducer } from "./types";

const initialState: OverviewTablesReducer = {
  byId: {},
  isLoading: false,
  filters: {},
};

const overviewTablesReducer = reducer(
  initialState,
  on(setOverviewTablesAction, (state, { payload: { tablesByTemplateId } }) => {
    state.byId = {
      ...state.byId,
      ...tablesByTemplateId,
    };
    state.isLoading = false;
  }),
  on(setOverviewTablesLoading, (state, { payload: { isLoading } }) => {
    state.isLoading = isLoading;
  }),

  on(
    setOverviewTablesFilter,
    (state, { payload: { tablesByTemplateId, templateId } }) => {
      state.filters = {
        ...state.filters,
        [templateId]: tablesByTemplateId,
      };
    }
  ),

  on(deleteOverviewTablesFilter, (state, { payload: { templateId } }) => {
    delete state.filters[Number(templateId)];
  })
);

export default overviewTablesReducer;
